import * as React from 'react';
import { SVGProps } from 'react';

const IconHelmetSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5.5a3 3 0 0 0-1.679-2.694.921.921 0 0 0-.612-.61C7.349 2.079 6.814 2 6 2c-.814 0-1.35.08-1.709.196a.921.921 0 0 0-.612.61A3 3 0 0 0 2 5.5v1.585A1.5 1.5 0 0 0 2.5 10h7a1.5 1.5 0 0 0 .5-2.915V5.5ZM4.63 3.138c0 .014 0 .032.004.056a.722.722 0 0 0 .045.157l.785 1.963a.5.5 0 0 1-.928.372l-.72-1.798C3.322 4.252 3 4.838 3 5.5V7h6V5.5c0-.662-.321-1.248-.816-1.612l-.72 1.798a.5.5 0 1 1-.928-.372l.785-1.963a.722.722 0 0 0 .05-.213C7.143 3.069 6.727 3 6 3s-1.144.07-1.37.138ZM2.5 8h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Z"
    />
  </svg>
);
export default IconHelmetSizeXs;
